import { IExpression } from "@@expressions";
import { IComponent } from "./IComponent";
import { ConfirmmationDialogModel } from "./ConfirmmationDialogModel";
import { IHasDisabled } from "./IHasDisabled";
import { GenericRefModel } from "./GenericRefModel";

export type ButtonModel = IComponent & IHasDisabled & {
  Label?: string;
  IconName?: string;
  IconColor?: string;
  Color?: string;
  Variant?: ButtonVariant;
  ConfirmationDialog?: ConfirmmationDialogModel;
  OnSelected?: IExpression;
  View?: GenericRefModel;
  ViewInput?: IExpression;
  OnViewReturned?: IExpression;
};

export enum ButtonVariant {
  Button = "Button",
  ButtonContained = "ButtonContained",
  ButtonOutlined = "ButtonOutlined",
  IconButton = "IconButton",
}





